/* Cart drawer (v2). Every change goes through Shopify's Ajax Cart API and the
   drawer is re-rendered from the cart-drawer section, so the markup on screen
   is always Liquid's view of the real cart. */
(() => {
  const SECTION = 'cart-drawer';
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const wrap = () => document.getElementById('shopify-section-' + SECTION);
  const drawer = () => (wrap() ? wrap().querySelector('[data-cart-drawer]') : null);
  if (!wrap()) return;

  let lastFocus = null;
  let pending = 0;

  const setCount = (n) => {
    document.querySelectorAll('.cart-count').forEach((el) => { el.textContent = n; });
  };
  const busy = (on) => {
    pending = Math.max(0, pending + (on ? 1 : -1));
    const d = drawer();
    if (d) d.classList.toggle('is-busy', pending > 0);
  };

  // Reservation clock. Ten minutes from the moment the cart gains items,
  // kept in localStorage so it survives reloads and every re-render. Once it
  // runs out the strip hides; adding more starts a fresh window.
  const HOLD_MS = 10 * 60 * 1000;
  const HOLD_KEY = 'svelna_cart_hold';
  const hold = {
    get() { try { return JSON.parse(localStorage.getItem(HOLD_KEY) || 'null'); } catch (e) { return null; } },
    set(v) { try { if (v) localStorage.setItem(HOLD_KEY, JSON.stringify(v)); else localStorage.removeItem(HOLD_KEY); } catch (e) {} },
  };
  // restart: an expired window starts again (used when the drawer opens).
  function syncHold(restart) {
    const d = drawer();
    const n = Number(d && d.dataset.count) || 0;
    if (n === 0) { hold.set(null); return; }
    const cur = hold.get();
    const now = Date.now();
    if (!cur || (cur.until <= now && (restart || n !== cur.count))) hold.set({ until: now + HOLD_MS, count: n });
    else if (n !== cur.count) hold.set({ until: cur.until, count: n });
  }
  function paintHold() {
    const d = drawer();
    const el = d && d.querySelector('[data-cart-timer]');
    if (!el) return;
    const cur = hold.get();
    const left = cur ? cur.until - Date.now() : 0;
    if (left <= 0) { el.hidden = true; return; }
    const s = Math.ceil(left / 1000);
    const clock = el.querySelector('[data-cart-timer-clock]');
    if (clock) clock.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    el.hidden = false;
  }
  window.setInterval(paintHold, 1000);

  // Flags the drawer while the body can still scroll further, so the foot
  // fade shows only when there really is more below.
  function syncMore() {
    const d = drawer(); const b = d && d.querySelector("[data-cart-body]");
    if (!d || !b) return;
    d.classList.toggle("has-more", b.scrollHeight - b.scrollTop - b.clientHeight > 6);
  }
  document.addEventListener("scroll", (e) => { if (e.target && e.target.matches && e.target.matches("[data-cart-body]")) syncMore(); }, true);
  document.addEventListener("load", (e) => { const d = drawer(); if (d && e.target && d.contains(e.target)) syncMore(); }, true);
  window.addEventListener("resize", syncMore);

  // Free gift. Earned only on the offer landing: pairs added there carry a hidden
  // _offer property, and the gift stays in the cart only while it holds at least one
  // such pair and `min` paid pairs in total. The cart is the proof, so having merely
  // seen the landing earns nothing. The landing's window.SvelnaGift is stored only so
  // the gift can still be added or corrected on other pages; on its own it gives
  // nothing. The gift is a real 0 EUR product so it appears on the order.
  let giftBusy = false;
  function giftConfig() {
    if (window.SvelnaGift && window.SvelnaGift.id) return window.SvelnaGift;
    try { return JSON.parse(localStorage.getItem('svelna_gift') || 'null'); } catch (e) { return null; }
  }
  // The only 0 EUR product is the gift. original_price ignores discounts, so a
  // free pair from a promotion or a referral never reads as one.
  const isGiftLine = (i) => i.original_price === 0;
  async function syncGift() {
    const cfg = giftConfig();
    if (giftBusy) return;
    const d0 = drawer();
    if ((!cfg || !cfg.id) && !(Number(d0 && d0.dataset.count) > 0)) return;
    giftBusy = true;
    try {
      const cart = await (await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const gifts = cart.items.filter(isGiftLine);
      const pairs = cart.items.filter((i) => !isGiftLine(i));
      const paid = pairs.reduce((n, i) => n + i.quantity, 0);
      const fromOffer = pairs.some((i) => i.properties && i.properties._offer);
      const earned = !!(cfg && cfg.id) && fromOffer && paid >= (Number(cfg.min) || 2);
      const extra = earned ? gifts.slice(1) : gifts;
      const wrong = earned && gifts.length > 0 && gifts[0].quantity !== 1;
      if (earned && !gifts.length) {
        await post('cart/add.js', { items: [{ id: cfg.id, quantity: 1, properties: { [cfg.prop || 'Dovana']: cfg.note || '' } }] });
      } else if (!extra.length && !wrong) {
        return;
      }
      for (const g of extra) await post('cart/change.js', { id: g.key, quantity: 0 });
      if (wrong) await post('cart/change.js', { id: gifts[0].key, quantity: 1 });
      giftBusy = false;
      await refresh();
      return;
    } catch (e) {
      /* the gift is a bonus; never let it break the cart */
    } finally {
      giftBusy = false;
    }
  }

  function render(html) {
    const w = wrap();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('shopify-section-' + SECTION);
    w.innerHTML = fresh ? fresh.innerHTML : html;
    const d = drawer();
    if (!d) return;
    setCount(d.dataset.count || '0');
    syncGift();
    syncHold();
    paintHold();
    syncMore();
    if (w.classList.contains('is-open')) d.removeAttribute('inert');
    else d.setAttribute('inert', '');
  }

  async function refresh() {
    busy(true);
    try {
      const res = await fetch(rootUrl + '?sections=' + SECTION, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      render(data[SECTION]);
    } finally { busy(false); }
  }

  async function post(path, body) {
    const res = await fetch(rootUrl + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTION }, body)),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.description || data.message || res.statusText), { data });
    return data;
  }

  // Stock note under a line: used when Shopify refuses a quantity (422) or gives fewer than
  // asked. Liquid prints the same note by itself once the line sits at its limit.
  function stockNote(line) {
    const d = drawer();
    const li = d && d.querySelector('.cdrawer__var[data-line="' + line + '"]');
    if (!li || li.dataset.max === undefined) return;
    if (d.querySelector('[data-stock-note="' + line + '"]')) return;
    const note = document.createElement('li');
    note.className = 'cdrawer__stock';
    note.dataset.stockNote = line;
    const max = parseInt(li.dataset.max, 10);
    note.textContent = li.dataset.stockText ? li.dataset.stockText
      : max === 1 ? 'Liko paskutinis vienetas šios spalvos.'
      : max < 1 ? 'Šios spalvos nebeliko.'
      : 'Šios spalvos liko tik ' + max + ' ' + (li.dataset.maxWord || 'poros') + '.';
    li.insertAdjacentElement('afterend', note);
  }

  async function change(line, quantity) {
    busy(true);
    let short = false;
    try {
      const data = await post('cart/change.js', { line, quantity });
      const got = data.items && data.items[line - 1] ? data.items[line - 1].quantity : null;
      if (quantity > 0 && got !== null && got < quantity) short = true;
      if (data.sections && data.sections[SECTION]) render(data.sections[SECTION]); else await refresh();
    } catch (e) {
      short = quantity > 0;
      await refresh();
    } finally { busy(false); }
    if (short) stockNote(line);
  }

  async function add(items) {
    busy(true);
    try {
      const data = await post('cart/add.js', { items });
      if (data.sections && data.sections[SECTION]) render(data.sections[SECTION]); else await refresh();
      open();
      return data;
    } finally { busy(false); }
  }

  function open() {
    const w = wrap(); const d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    w.classList.add('is-open');
    d.removeAttribute('inert');
    document.documentElement.classList.add('cart-open');
    syncHold(true);
    paintHold();
    window.requestAnimationFrame(syncMore);
    const x = d.querySelector('[data-cart-close].cdrawer__x, .cdrawer__x');
    window.setTimeout(() => { if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    const w = wrap(); const d = drawer();
    if (!w.classList.contains('is-open')) return;
    w.classList.remove('is-open');
    if (d) d.setAttribute('inert', '');
    document.documentElement.classList.remove('cart-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  // Delegated: survives every re-render.
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener) { e.preventDefault(); refresh().then(open); return; }
    const d = drawer();
    if (!d || !d.contains(e.target)) return;
    const closer = e.target.closest('[data-cart-close]');
    if (closer) { if (closer.tagName !== 'A') e.preventDefault(); close(); return; }
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      const line = Number(qty.dataset.cartQty);
      const input = d.querySelector('[data-cart-qty-input="' + line + '"]');
      const next = Math.max(0, (Number(input && input.value) || 0) + Number(qty.dataset.delta));
      change(line, next);
      return;
    }
    // Free-pair box: the size switch shows that size's colours; a colour button is a normal add.
    const nsize = e.target.closest('[data-nudge-size]');
    if (nsize) {
      const boxEl = nsize.closest('[data-nudge]');
      boxEl.querySelectorAll('[data-nudge-size]').forEach((b) => { const on = b === nsize; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      boxEl.querySelectorAll('[data-nudge-cols]').forEach((g) => { g.hidden = g.dataset.nudgeCols !== nsize.dataset.nudgeSize; });
      return;
    }
    const addon = e.target.closest('[data-cart-addon]');
    if (addon) {
      e.preventDefault();
      const item = { id: Number(addon.dataset.cartAddon), quantity: 1 };
      if (addon.dataset.presale) item.properties = { [addon.dataset.presaleKey || '_Išankstinis užsakymas']: addon.dataset.presale };
      add([item]);
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { change(Number(rm.dataset.cartRemove), 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    change(Number(input.dataset.cartQtyInput), Math.max(0, Number(input.value) || 0));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Boot: the drawer arrives inert from the server; the count badge in the header already matches.
  const d = drawer();
  if (d) d.setAttribute('inert', '');
  syncHold();
  paintHold();
  syncMore();
  syncGift();

  // /cart (where checkout's "return to cart" lands) sends people back here with ?krepselis=1:
  // open the drawer and tidy the address. Shopping pages are remembered for that trip back.
  try {
    const url = new URL(location.href);
    if (url.searchParams.has('krepselis')) {
      url.searchParams.delete('krepselis');
      history.replaceState(null, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
      refresh().then(open);
    }
    const rel = location.pathname;
    if (rel.indexOf('/products/') === 0 || rel.indexOf('/collections/') === 0) {
      const keep = new URL(location.href); keep.searchParams.delete('cb'); keep.searchParams.delete('krepselis');
      localStorage.setItem('svelna_last_page', keep.pathname + (keep.searchParams.toString() ? '?' + keep.searchParams.toString() : ''));
    }
  } catch (e) {}

  // Back from checkout (or any bfcache restore): the page is the old snapshot, the cart is not. Re-read it.
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });

  // Which button started the purchase (owner test 2026-11-03): cart attribute pirkimo_mygtukas = 'pirkti_dabar' | 'i_krepseli'
  // (shows under the order's additional details) plus a Clarity event. Never slows the shopper: 800 ms cap, errors ignored.
  // onlyIfEmpty keeps an earlier 'pirkti_dabar' so we know which button started the purchase.
  async function mark(value, onlyIfEmpty) {
    try { if (window.clarity) { window.clarity('event', value + '_click'); window.clarity('set', 'pirkimo_mygtukas', value); } } catch (e) {}
    const ctl = new AbortController(); const timer = setTimeout(() => ctl.abort(), 800);
    try {
      if (onlyIfEmpty) { const c = await (await fetch(rootUrl + 'cart.js', { signal: ctl.signal })).json(); if (c.attributes && c.attributes.pirkimo_mygtukas) return; }
      await fetch(rootUrl + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { pirkimo_mygtukas: value } }), signal: ctl.signal });
    } catch (e) {} finally { clearTimeout(timer); }
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.cdrawer__checkout'); if (!a) return;
    e.preventDefault(); mark('i_krepseli', true).then(() => { window.location.href = a.href; });
  });

  window.SvelnaCart = { open, close, refresh, render, add, change, syncGift, mark };
})();
